import { getItemFromCollection } from "directus/src/operations";

export async function fetchQuestionData({ questionId }) {
  try {
    const response = await getItemFromCollection("survey_questions", questionId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
